// extracted by mini-css-extract-plugin
export default {"feedSettingsName":"update-details-page-feedSettingsName-O45GPJ","serverType":"update-details-page-serverType-Mh0nfP","link":"update-details-page-link-aDkauw"};